import { Building2, Tag, Users } from 'lucide-react'

interface MobileStatsBarProps {
  offices: string | number | null
  users: string | number | null
  price: string | number | null
  AvgPrice: string | number | null
}

const MobileStatsBar = ({ offices, users, price, AvgPrice }: MobileStatsBarProps) => {
  return (
    <div className="flex items-center gap-4 mt-4 bg-white rounded  text-sm text-gray-800 overflow-x-auto scrollbar-hide">
      {offices ? (
        <div className="flex items-center gap-2 align-center w-fit justify-center">
          <Building2 className="w-5 h-5" />
          <span className="font-medium text-sm md:text-base text-oh-black">{offices}</span>
        </div>
      ) : null}
      {users ? (
        <div className="w-fit flex items-center gap-2 align-center justify-center">
          <Users className="w-5 h-5" />
          <span className="font-medium text-sm md:text-base text-oh-black">{users}</span>
        </div>
      ) : ""}
      {price ? (
        <div className="w-fit flex items-center gap-2 align-center justify-center">
          <Tag className="w-5 h-5" />
          <span className="font-medium text-sm md:text-base text-oh-black">{price}</span>
        </div>
      ) : null}
      {AvgPrice ? (
        <div className="w-fit flex items-center gap-2 align-center justify-center">
          <Tag className="w-5 h-5" />
          <span className="font-medium text-sm md:text-base text-oh-black">{AvgPrice}</span>
        </div>
      ) : null}
    </div>
  )
}

export default MobileStatsBar